import React from "react";
import { MapAndTransformContainer } from "../../../containers";

const MapAndTransform = (props) => {
  return <MapAndTransformContainer {...props} />;
};

export default MapAndTransform;
